
import React, { useEffect, useState } from "react";
import ActionButton from "../../components/ActionButton";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import DashboardLayout from "../../components/DashboardLayout";
import DashboardCard from "../../components/DashboardCard";
import { LIGHT_BLUE_COLOR } from "../../constants";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useForm } from "react-hook-form";
import ShowErrorAlert from "../../components/ErrorAlert";
import { extractErrorMessage } from "../../utils";
import axios from "axios";
import { BASE_URL } from "../../constants";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import DashboardHeading from "../../components/DashboardHeading";
import Label from "../../components/Label";
import CustomInput from "../../components/CustomInput";
import { PRICE_MASTER_FIELDS } from "./Config.constant";
import ConfigurationsHeader from "./ConfigurationsHeader";
import CustomSelect from "../../components/CustomSelect";
import ShowSuccessAlert from "../../components/SuccessAlert";

const UpdateUnit = () => {

    const { priceMasterId: id } = useParams();
    const navigate = useNavigate();

    const {
        handleSubmit,
        formState: { errors },
        getValues,
        control,
        reset
    } = useForm({
        defaultValues: {
            unit: "", 
            updateUnit: id
        }
    });

    // Redux Store
    const {
        auth: {
            token,
            user: { _id: userId },
        },
    } = useSelector((state) => state);

    // State Variables
    const [loading, setLoading] = useState(false);
    const [priceMasterId, setPriceMasterId] = useState(id);
    const [priceMasters, setPriceMasters] = useState(null);

    async function updateServiceTypeReq(body) {
        setLoading(true);
        try {
            await axios.put(`${BASE_URL}/users/${userId}/priceMasters/${priceMasterId}`, body, {
                headers: {
                    Authorization: token,
                },
            });
            ShowSuccessAlert("Unit updated successfully");
            setTimeout(()=>{
                setLoading(false);
                navigate("/admins/configurations/units");
            }, 2000);
            // getPriceMasters();
        } catch (err) {
            setLoading(false);
            console.log(err);
            ShowErrorAlert(extractErrorMessage(err));
        }
    }

    async function getPriceMasters(body) {
        setLoading(true);
        try {
            const {
                data: { priceMasters },
            } = await axios.get(`${BASE_URL}/users/${userId}/priceMasters`, {
                headers: {
                    Authorization: token,
                },
            });

            const priceMasterObj = preparePriceMasterObj(priceMasters);
            setPriceMasters(priceMasterObj);
            // if(priceMasters && priceMasters.length > 0){
            //     setPriceMasterId(priceMasters[0]._id);
            // }
            // reset({unit: priceMasters[0].unit})
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log(err);
            ShowErrorAlert(extractErrorMessage(err));
        }
    }

    const preparePriceMasterObj = (service) => {
        for (let [key, value] of service.entries()) {
            let selected = false;
            if (!key) selected = true;
            service[key] = { _id: value._id, label: value.unit, value: value._id, selected, unit: value.uint }
        }
        return service;
    }

    function onSubmit(data) {
        updateServiceTypeReq(data);
    }

    function onChangePriceMaster(e) {
        const selectedIndex = e.target.selectedIndex;
        setPriceMasterId(priceMasters[selectedIndex]._id);
        let updatedServiceType = [...priceMasters];
        for (let [index, serviceType] of updatedServiceType.entries()) {
            if (index !== selectedIndex) {
                serviceType.selected = false;
            } else {
                serviceType.selected = true;
            }
        }
        setPriceMasters(updatedServiceType);
        reset({unit: priceMasters[selectedIndex].unit})
    }

    useEffect(() => {
        getPriceMasters();
    }, []);

    return (
        <DashboardLayout >
            <ConfigurationsHeader />
            <DashboardCard backgroundColor={LIGHT_BLUE_COLOR}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex justify-between align-center">
                        <div className="flex align-center">
                            <span style={{cursor: "pointer"}} onClick={() => navigate("/admins/configurations/units")}>
                                <MdOutlineArrowBackIosNew size={20} />
                            </span>
                            <DashboardHeading>Update</DashboardHeading>
                        </div>
                        <ActionButton type="submit" disabled={loading}>
                            {loading ? <ClipLoader color="black" size={20} /> : "Update"}
                        </ActionButton>
                    </div>
                    {/* form starts here */}
                    <DashboardCard>
                        <Label required="true">Old Unit Name</Label>
                        <CustomSelect
                            name={"updateUnit"}
                            control={control}
                            errors={errors}
                            errorText={"Unit is required"}
                            options={priceMasters ? priceMasters : []}
                            onHandleChange={onChangePriceMaster}
                            disabled={true}
                        />
                        {PRICE_MASTER_FIELDS(getValues).map(
                            ({ name, required, label, type, rules, errorText }) => (
                                <div key={name} className="mt-3">
                                    <Label required={required}>{label}</Label>
                                    <CustomInput
                                        name={name}
                                        type={type}
                                        control={control}
                                        rules={rules}
                                        errors={errors}
                                        errorText={errorText}
                                    />
                                </div>
                            )
                        )}
                    </DashboardCard>
                </form>
            </DashboardCard>
            {/* <DashboardCard backgroundColor={LIGHT_BLUE_COLOR}>
                <div style={{display: "flex", flexDirection: "row"}}>
                <span style={{fontSize: "32px"}}>OR</span>
                <Link style={{width: "fit-content", marginLeft: "24px"}} to="/admins/configurations/priceMasters"  >
                    <ActionButton style={{ height: "55px" }} className={"flex-shrink-1"}>
                        <FiEdit color="white" size={20} className="me-2" />
                        <small>All Price Master</small>
                    </ActionButton></Link>
                <Link style={{width: "fit-content", marginLeft: "24px"}} to="/admins/configurations/addPriceMaster"  >
                    <ActionButton style={{ height: "55px" }} className={"flex-shrink-1"}>
                        <FiEdit color="white" size={20} className="me-2" />
                        <small>Add Price Master</small>
                    </ActionButton></Link>
                </div>
            </DashboardCard> */}
        </DashboardLayout>

    )
}

export default UpdateUnit;